import { Factory } from '..'
import { SettingSchema } from '../schema/setting.schema'
import {
  attachRaw,
  attachUnknown,
  getUnknown,
  isDegraded,
  parseEntity,
  unwrapLegacyExtras,
  wireEntity,
} from '../../_utils/fcdc-v2'

export class Setting<T> {
  // New wrapper fields (siblings of actual): assign in the constructor before bindForwardCompatible runs.
  notOverridable: boolean
  actual: T | null
  countryOverrideIllegal?: boolean

  constructor(json: any) {
    const source = unwrapLegacyExtras(
      json && typeof json === 'object' ? json : {}
    ) as any
    this.notOverridable = source.notOverridable
    this.actual = source.actual
    this.countryOverrideIllegal = source.countryOverrideIllegal

    const parsed = parseEntity(SettingSchema, source)
    const unknown = getUnknown(parsed)
    if (unknown.includes('actual')) {
      this.actual = undefined as T
    }
    if (unknown.includes('notOverridable')) {
      this.notOverridable = undefined as unknown as boolean
    }
    if (unknown.includes('countryOverrideIllegal')) {
      this.countryOverrideIllegal = undefined
    }
    attachRaw(this, source)
    attachUnknown(this, unknown, isDegraded(parsed))
  }

  toJSON(): Record<string, unknown> {
    return wireEntity(this) as Record<string, unknown>
  }

  static getFactory<T>(): Factory<Setting<T>> {
    return new (class implements Factory<Setting<T>> {
      make(json: any): Setting<T> {
        return new Setting<T>(json)
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a Setting. Settings are not stored in IndexDB.'
        )
      }
    })()
  }
}
